var path = '/shared/javascripts/templates/svelte_page.html';
var html = "<angular-to-svelte svelte-component=\"svelteComponentConstructor\" props=\"svelteProps\">\n</angular-to-svelte>\n";
window.angular.module('tiz').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;